/**
 * @atlas
 * @kind registry
 * @partOf primitive:shared, primitive:websockets
 * @uses none
 */
import { channelKey } from './channelKey';

// gloss
export const WS_CHANNELS = {
  brandReferenceRequestsRead: {
    type: 'query',
    name: (uuid: string) => channelKey({ _id: 'brandReferenceRequestsRead', path: { uuid } }),
  },
  // why: this channel's route is deliberately unguarded - the unguessable uuid itself is the
  // why: capability (magic-link model), not a missing auth check
  brandReferenceRequestsSchedulingReadSlotsReferenceId: {
    type: 'query',
    name: (uuid: string) =>
      channelKey({ _id: 'brandReferenceRequestsSchedulingReadSlotsReferenceId', path: { referenceID: uuid } }),
  },
  groupsConditionsSchema: {
    type: 'query',
    isBrandScoped: true,
    name: (brandUuid: string) => channelKey({ _id: 'groupsConditionsSchema', brandUuid }),
  },
} as const;

export type WSChannelFamily = keyof typeof WS_CHANNELS;
